@if (visible) {
  <section class="user-products" aria-labelledby="user-products-heading">
    <div class="products-heading">
      <h2 id="user-products-heading">Products</h2>
      <button type="button" mat-stroked-button (click)="load()" [disabled]="state === 'loading'">{{state === 'error' ? 'Retry' : 'Reload records'}}</button>
    </div>
    <p class="products-note">Recorded Wallit state only. Live provider freshness and completeness are not checked. Reload reads saved records.</p>
    @if (state === 'loading') {
      <p role="status">Loading products…</p>
    }
    @if (state === 'error') {
      <p role="alert">Unable to load products. Profile editing remains available. Try again.</p>
    }
    @if (state === 'loaded') {
      @if (products.length === 0) {
        <p>No recorded products or dependent-access products found.</p>
      }
      @for (product of currentProducts; track product) {
        <ng-container *ngTemplateOutlet="productCard; context: {$implicit: product}"></ng-container>
      }
      @if (terminatedProducts.length) {
        <details class="terminated-products">
          <summary>Terminated products ({{terminatedProducts.length}})</summary>
          @for (product of terminatedProducts; track product) {
            <ng-container *ngTemplateOutlet="productCard; context: {$implicit: product}"></ng-container>
          }
        </details>
      }
    }
  </section>
}

<ng-template #productCard let-product>
  <article class="product-card">
    <h3>{{product.vendorName || 'Unknown vendor'}} · {{product.productName || 'Unknown product'}}</h3>
    <p class="access-label">{{product.access === 'dependent' ? 'Dependent access · primary user owns this product' : 'Direct product'}}</p>
    <div class="product-status-grid">
      <div><strong>Enrollment</strong><p>{{enrollmentLabel(product)}}</p>
      @if (product.enrollment.state === 'post') {
        <p>{{product.enrollment.confirmed === true ? 'Confirmed by recorded evidence' : product.enrollment.confirmed === false ? 'Not confirmed by recorded evidence' : 'Confirmation unknown'}}</p>
      }
      <p>Effective date: {{product.enrollment.effectiveDate || 'Unknown'}}@if (product.enrollment.effectiveDate) {
        <span> (recorded; does not establish current coverage)</span>
      }</p>
    </div>
    <div><strong>Billing</strong><p>{{billingLabel(product.billing.status)}}</p>
    <p>Subscription status: {{product.billing.subscriptionStatus || 'Unknown'}}</p>
    <p class="products-note">Billing status does not determine enrollment.</p>
  </div>
</div>
<p>Recorded plan: {{product.enrollment.plan || 'Unknown'}} · Coverage: {{coverageLabel(product.enrollment.coverage)}}</p>
<p>Enrollment / termination record: {{product.enrollment.recordedAt ? (product.enrollment.recordedAt | date:'medium') : 'Unknown'}}</p>
@if (product.recentActivity.length) {
  <div class="product-activity">
    <strong>Recent attempts and updates</strong>
    <p class="products-note">Activity since the latest enrollment or termination record. Outcomes are not inferred from attempts.</p>
    <ul>@for (event of product.recentActivity; track event) {
      <li>{{phaseLabel(event.phase)}} · {{event.recordedAt | date:'medium'}}@if (event.plan) {
        <span> · {{event.plan}}</span>
        }@if (event.coverage) {
        <span> · {{coverageLabel(event.coverage)}}</span>
      }</li>
    }</ul>
  </div>
}
<details>
  <summary>Recorded dates and lifecycle history ({{product.history.length}})</summary>
  <p>Recorded enrollment refresh: {{product.enrollment.recordedRefreshAt ? (product.enrollment.recordedRefreshAt | date:'medium') : 'Unavailable'}}</p>
  <p>Latest lifecycle record: {{product.latestRecordAt | date:'medium'}}</p>
  <p>Billing snapshot timestamp: {{product.billing.snapshotTimestamp ? (product.billing.snapshotTimestamp | date:'medium') : 'Unavailable'}}</p>
  <p>Billing state timestamp: {{product.billing.stateTimestamp ? (product.billing.stateTimestamp | date:'medium') : 'Unavailable'}}</p>
  <p class="products-note">Stored billing timestamps may be fallback dates; they do not indicate a provider verification or sync.</p>
  @if (product.billing.nextRetryAt) {
    <p>Next retry recorded: {{product.billing.nextRetryAt | date:'medium'}}</p>
  }
  @if (product.billing.cancelAt) {
    <p>Cancellation scheduled: {{product.billing.cancelAt | date:'medium'}}</p>
  }
  @if (product.billing.canceledAt) {
    <p>Billing cancelled: {{product.billing.canceledAt | date:'medium'}}</p>
  }
  <ol class="product-history">@for (event of product.history; track event) {
    <li>
      <strong>{{phaseLabel(event.phase)}}</strong> · {{event.recordedAt | date:'medium'}}
      <p>Record modified: {{event.modifiedAt ? (event.modifiedAt | date:'medium') : 'Unknown'}}</p>
      <p>Plan: {{event.plan || 'Unknown'}} · Coverage: {{coverageLabel(event.coverage)}} · Effective date: {{event.effectiveDate || 'Unknown'}}</p>
      <p>Billing: {{billingLabel(event.billing.status)}} · Subscription: {{event.billing.subscriptionStatus || 'Unknown'}}</p>
    </li>
  }</ol>
</details>
</article>
</ng-template>
